import { TicketStatuses } from "./../../enums/TicketStatuses.enum";
import { ApiTicketService } from "./../../services/api/api-ticket.service";
import { SocketService } from "./../../services/socket/socket.service";
import { Component, Inject, Input, OnDestroy, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { environment } from "environments/environment";
import { filter, merge, Subscription } from "rxjs";

@Component({
  standalone: false,
    selector: "fuse-dialog-news",
    templateUrl: "./dialog-news.component.html",
    styleUrls: ["./dialog-news.component.scss"],
})
export class DialogNewsComponent implements OnInit, OnDestroy {
    public base_url = environment.api_url;
    public type: string;
    public source: string;
    public title: string;
    public description: string;
    public label: string;
    public ticketServiceRef: any;
    private updateTicketSubscription: Subscription;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<DialogNewsComponent>,
        private socket: SocketService,
        private ticketService: ApiTicketService
    ) {
        if (environment.closeNewsModalAutomatically) {
            if (!this.data?.ticketID) {
                return;
            }
            this.updateTicketSubscription = merge(
                this.ticketService.getFromId(this.data?.ticketID),
                this.socket.getMessage("onTicketUpdated")
            )
                .pipe(filter((ticket) => ticket.id === this.data?.ticketID))
                .subscribe((ticket) => {
                    if (ticket.id_status === TicketStatuses.ONLINE) {
                        this.dialogRef.close();
                    }
                });
        }
    }

    ngOnInit(): void {
        this.type = this.data?.slide.type;
        this.source = this.base_url + this.data?.slide.mediaUrl;
        this.title = this.data?.slide.title;
        this.description = this.data?.slide.description;
        this.label = this.data?.slide.label;
    }

    ngOnDestroy(): void {
        this.updateTicketSubscription.unsubscribe();
    }
}
